import { inject } from '@angular/core';
import { CanActivateFn, Params, Router } from '@angular/router';
import { StorageService } from '../services';
import {
  normalizeVehiclesCollapsedRows,
  parseVehiclesFiltersFromStorage,
  serializeVehiclesCollapsedRows,
  serializeVehiclesFilters,
  serializeVehiclesViewOptions,
} from '../filters';
import { normalizeViewOptions } from '../components/vehicles/scheduleViewOptions';

export const vehiclesHydrationGuard: CanActivateFn = async (route, state) => {
  if (route.queryParamMap.keys.length > 0) return true;

  const storage = inject(StorageService);
  const router = inject(Router);

  const [storedFilters, storedViewOptions, storedCollapsedRows] = await Promise.all([
    storage.getVehiclesFilters().then(parseVehiclesFiltersFromStorage),
    storage.getVehiclesViewOptions(),
    storage.getVehiclesCollapsedRows(),
  ]);
  const serialized: Params = {
    ...(storedFilters ? serializeVehiclesFilters(storedFilters) : {}),
    ...(storedViewOptions ? serializeVehiclesViewOptions(normalizeViewOptions(storedViewOptions)) : {}),
    ...(storedCollapsedRows ? serializeVehiclesCollapsedRows(normalizeVehiclesCollapsedRows(storedCollapsedRows)) : {}),
  };

  const queryParams: { [key: string]: string } = {};
  for (const [key, value] of Object.entries(serialized)) {
    if (value != null && value !== '') queryParams[key] = value as string;
  }
  if (Object.keys(queryParams).length === 0) return true;

  const path = state.url.split('?')[0];
  return router.createUrlTree([path], { queryParams });
};
